import { render, staticRenderFns } from "./GuardianOfChildBestInterestsOfChild.vue?vue&type=template&id=1288d273"
import script from "./GuardianOfChildBestInterestsOfChild.vue?vue&type=script&lang=ts"
export * from "./GuardianOfChildBestInterestsOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports